import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '0.5rem',
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: '0.5rem',
    boxSizing: 'border-box',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.35)',
    minHeight: '54px',
    height: '54px',
    maxHeight: '54px',
    padding: '1rem',
    cursor: 'pointer',
    backgroundColor: 'white',
    transition: 'all 400ms ease-in-out',

    '&:hover': {
      backgroundColor: theme.palette.secondary.main
    }
  },

  loading: {
    cursor: 'default',
    backgroundColor: 'lightgray'
  },

  loadingIcon: {
    marginRight: '0.5rem'
  },

  title: {
    whiteSpace: 'nowrap'
  },

  deleteIcon: {
    flexShrink: '0',
    marginLeft: '0.5rem'
  }
}))

export default useStyles
